/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is X% of a number?`)
};

const es_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es el X% de un número?`)
};

const de_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist X % einer Zahl?`)
};

const nl_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is X% van een getal?`)
};

const fr_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est X % d'un nombre ?`)
};

const it_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è il X% di un numero?`)
};

const pt_br2_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto é X% de um número?`)
};

const pt_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto é X% de um número?`)
};

const ja_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ある数のX%は？`)
};

const zh_pct_hub_mode1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个数的 X% 是多少？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_mode1_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_mode1_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_mode1_title", locale)
	if (locale === "en") return en_pct_hub_mode1_title(inputs)
	if (locale === "es") return es_pct_hub_mode1_title(inputs)
	if (locale === "de") return de_pct_hub_mode1_title(inputs)
	if (locale === "nl") return nl_pct_hub_mode1_title(inputs)
	if (locale === "fr") return fr_pct_hub_mode1_title(inputs)
	if (locale === "it") return it_pct_hub_mode1_title(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_mode1_title(inputs)
	if (locale === "pt") return pt_pct_hub_mode1_title(inputs)
	if (locale === "ja") return ja_pct_hub_mode1_title(inputs)
	return zh_pct_hub_mode1_title(inputs)
};